// extracted by mini-css-extract-plugin
export default {"sendForm":"MessageSender_sendForm__ej8y1","textarea":"MessageSender_textarea__pcNAy","button":"MessageSender_button__s+eCG"};